import { createFileRoute, redirect } from '@tanstack/react-router'
import { TransactionsPage } from '../pages/TransactionsPage'
import { useAuthStore } from '../stores/auth-store'

/**
 * Filters carried in the URL, so a dashboard row or category bar (issue #27)
 * can open the list already narrowed. Validated, not trusted: anything
 * malformed is dropped rather than sent to the API.
 */
export interface TransactionsSearch {
  category_id?: string
  category?: string
  start_date?: string
  end_date?: string
  /** "1" opens the Needs review queue. */
  review?: string
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const YMD = /^\d{4}-\d{2}-\d{2}$/

export function parseTransactionsSearch(search: Record<string, unknown>): TransactionsSearch {
  const str = (v: unknown) => (typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined)
  const date = (v: unknown) => {
    const s = str(v)
    return s && YMD.test(s) ? s : undefined
  }
  const id = str(search.category_id)
  return {
    category_id: id && UUID.test(id) ? id : undefined,
    category: str(search.category)?.slice(0, 100),
    start_date: date(search.start_date),
    end_date: date(search.end_date),
    review: search.review === '1' || search.review === 1 ? '1' : undefined,
  }
}

export const Route = createFileRoute('/transactions' as any)({
    component: TransactionsPage,
    validateSearch: parseTransactionsSearch,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
